import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const changeRequestPoliciesAPI = createApi({
    reducerPath: 'changeRequestPoliciesAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getChangeRequestPolicies: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.LIST_CHANGE_REQUEST_POLICIES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        searchChangeRequestPolicies: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_CHANGE_REQUEST_POLICIES_ACTION}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        preCreateChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        createChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        preModifyChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_MODIFY_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        modifyChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        displayChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DISPLAY_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        deleteChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
        getPositionsMappedToChangeRequestPolicy: builder.mutation({
            query: ({ data, query }) => ({
                url: `${API_ENDPOINTS.GET_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY}?${query.toString()}`,
                method: 'POST',
                data,
            }),
        }),
        bulkUpdatePositionChangeRequestPolicyMappings: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.UPDATE_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetChangeRequestPoliciesMutation,
    useSearchChangeRequestPoliciesMutation,
    usePreCreateChangeRequestPolicyMutation,
    useCreateChangeRequestPolicyMutation,
    usePreModifyChangeRequestPolicyMutation,
    useModifyChangeRequestPolicyMutation,
    useDisplayChangeRequestPolicyMutation,
    useDeleteChangeRequestPolicyMutation,
    useGetPositionsMappedToChangeRequestPolicyMutation,
    useBulkUpdatePositionChangeRequestPolicyMappingsMutation,
} = changeRequestPoliciesAPI;
